$(document).ready(
    function () {
        const body = $("body");
        let p = body.attr("p");
        let a = body.attr("a");
        let type = body.attr("type");

        if (p === 'organizer_event_ticket_category' && (type === 'combo' || a === 'update' || a === 'new')) {
            $('.combo-category-wrapper .combo-category-select').select2({
                theme: 'bootstrap4'
            });

            $(document).on("click", ".combo-category-wrapper .combo-category-remove", function () {
                $(this).closest('.combo-category-wrapper').remove();
            });

            $(document).on("click", ".combo-selection-group .combo-group-remove", function () {
                $(this).closest('.combo-selection-group').remove();
            });

            let event_combo_group_lock = false;
            $(document).on("click", "#event_combo_form_wrapper #combo-group-category-add", function () {
                if (!event_combo_group_lock) {
                    const eventId = $("#event_id").val();
                    const groupId = $('.combo-group-category-sub-add:last').data("group-id") * 1 + 1;
                    event_combo_group_lock = true;

                    $.ajax({
                        type: 'GET',
                        url: "/ajax/event_combo/group",
                        data: {
                            event_id: eventId,
                            group_id: groupId
                        }
                    })
                        .done(function (data) {
                            if (data.message !== undefined && data.message !== null) {
                                $(".combo-selection-group:last").after(data.message);

                                $('.combo-category-wrapper .combo-category-select').select2({
                                    theme: 'bootstrap4'
                                });
                            }
                        })
                        .fail(function (data) {
                            if (data.responseJSON.error_message !== undefined && data.responseJSON.error_message !== null) {
                                prependAlert('#combo-group-category-add', data.responseJSON.error_message, 'danger', null, '#event_combo_form_wrapper')
                            }
                            event_combo_group_lock = false;

                        })
                        .always(function () {
                            event_combo_group_lock = false;
                        });
                }
            });

            let event_combo_group_sub_add_lock = false;
            $(document).on("click", ".combo-selection-group .combo-group-category-sub-add", function () {
                if (!event_combo_group_sub_add_lock) {
                    const eventId = $("#event_id").val();
                    const groupId = $(this).data("group-id");
                    const button = $(this);
                    event_combo_group_sub_add_lock = true;

                    $.ajax({
                        type: 'GET',
                        url: "/ajax/event_combo/group_select",
                        data: {
                            event_id: eventId,
                            group_id: groupId
                        }
                    })
                        .done(function (data) {
                            if (data.message !== undefined && data.message !== null) {
                                $(button).before(data.message);

                                $('.combo-category-wrapper .combo-category-select').select2({
                                    theme: 'bootstrap4'
                                });
                            }
                        })
                        .fail(function (data) {
                            if (data.responseJSON.error_message !== undefined && data.responseJSON.error_message !== null) {
                                prependAlert('#combo-group-category-sub-add-', data.responseJSON.error_message, 'danger')
                            }
                            event_combo_group_sub_add_lock = false;

                        })
                        .always(function () {
                            event_combo_group_sub_add_lock = false;
                        });
                }
            });
        }
    }
);